import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const IconPicker = (props) => {
    const iconPickButton = React.useRef();
    React.useEffect(() => {
        // @ts-expect-error - TS7034 - Variable 'iconPicker' implicitly has type 'any' in some locations where its type cannot be determined.
        let iconPicker = null;
        if (iconPickButton.current) {
            // @ts-expect-error - TS2581 - Cannot find name '$'. Do you need to install type definitions for jQuery? Try `npm i --save-dev @types/jquery`.
            iconPicker = $(iconPickButton.current).iconpicker({
                selected: props.value,
                component: ".btn > span",
            });
            // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
            iconPicker.on("iconpickerSelected", (event) => 
            // $FlowFixMe iconPickerValue is defined.
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            props.onChange(event.iconpickerValue));
        }
        return () => {
            // @ts-expect-error - TS7005 - Variable 'iconPicker' implicitly has an 'any' type.
            if (iconPicker) {
                // @ts-expect-error - TS2581 - Cannot find name '$'. Do you need to install type definitions for jQuery? Try `npm i --save-dev @types/jquery`. | TS7005 - Variable 'iconPicker' implicitly has an 'any' type.
                $.iconpicker.batch(iconPicker, "destroy");
            }
        };
    }, [props]);
    return (_jsxs(_Fragment, { children: [_jsx("button", { 
                // @ts-expect-error - TS2322 - Type 'MutableRefObject<HTMLButtonElement | null | undefined>' is not assignable to type 'LegacyRef<HTMLButtonElement> | undefined'.
                ref: iconPickButton, type: "button", className: "btn btn-outline-dark dropdown-toggle", "data-toggle": "dropdown", children: _jsx("span", { className: "fa-lg fa-fw", "aria-hidden": "true" }) }), _jsx("div", { className: "dropdown-menu shadow" })] }));
};
export default IconPicker;
